import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CoachMarkComponent } from './coach-mark.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    declarations: [CoachMarkComponent],
    exports: [CoachMarkComponent]
})
export class CoachMarkModule { }
